<template>
  <div :class="classes" :style="{'min-height':minHeight}"  @click="_doRetry">
    <wt-box v-show="boxLoading" :class="['wt-loading-box__sprite', `wt-loading-box__sprite--${spritePosition}`]">
      <slot name="sprite">
        <cube-loading></cube-loading>
      </slot>
    </wt-box>
    <wt-box v-if="isShowTip" class="tip wt-loading-box__notice">
        <p class="text">{{tip}}</p>
    </wt-box>
    <template v-if="isShowRetry">
      <p class="text-slot" v-if="hasErrSlot">
        <slot name="error"/>
      </p>
      <wt-box  v-else class="retry wt-loading-box__notice">
        <template>
        <p class="text">{{retryMessage}}</p>
        <p class="doRetry text">点击重试下？</p>
        </template>
      </wt-box>
    </template>
    <slot v-if="showContent"/>
  </div>
</template>

<script>
import cubeLoading from 'cube-ui/src/modules/loading'
// 组件class前缀
const prefixCls = 'wt-loading-box'

export default {
  name: 'wt-loading-box',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    minHeight: {
      type: String,
      default: '100px'
    },
    spritePosition: {
      type: String,
      default: 'top',
      validarot (val) {
        return ['top', 'center'].some(item => item === val)
      }
    }
  },
  data () {
    return {
      boxLoading: this.loading,
      isShowTip: false,
      isShowRetry: false,
      tip: '暂无数据',
      retryMessage: '￣へ￣，好像出了点意外！',
      hasErrSlot:false
    }
  },
  watch: {
    loading () {
      this._reset()
      this.boxLoading = this.loading
    }
  },
  components: {
    cubeLoading
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    showContent () {
      return !this.boxLoading && !this.isShowTip && !this.isShowRetry
    }
  },
  methods: {
    showTip (message) {
      this._reset()
      this.tip = message || this.tip
      this.$nextTick(_ => { // 这里在下一帧执行，是为了保证执行时机在loading属性的watch回调执行后
        this.isShowTip = true
      })
    },
    showRetry (message) {
      this._reset()
      this.retryMessage = message || this.retryMessage
      this.$nextTick(_ => { // 这里在下一帧执行，是为了保证执行时机在loading属性的watch回调执行后
        this.isShowRetry = true
      })
    },
    _doRetry (message) {
      if (this.isShowRetry) {
        this._reset()
        this.boxLoading = true
        this.$emit('on-retry')
      }
    },
    _reset () {
      this.boxLoading = false
      this.isShowTip = false
      this.isShowRetry = false
    }
  },
  created(){
    //是否有错误插槽，如果有，就不使用默认插槽
    console.log('hasErrSlot',this.$slots)
    this.hasErrSlot=this.$slots&&this.$slots.error&&this.$slots.error.length
  }
}
</script>

<style lang="less">
/* 组件库组件禁止使用 module */
.wt-loading-box{
  position: relative;
    &__sprite{
      padding:10px;
      &--center{
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        height:100%!important;
      }
    }
    &__notice{
      height:100%;
    }
    .text{
        color:#ccc;
        margin:8px 0;
    }
    .text-slot{
        color:#ccc;
    }
    .doRetry{

    }
}

</style>
